import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatSortModule } from '@angular/material/sort';
import { RouterModule } from '@angular/router';

import { MgButtonModule } from '@app/src/app/button';
import { MgEmptyStateModule } from '@app/src/app/components/EmptyState';
import { PeopleSearchInputModule } from '@app/src/app/components/people-search-input';
import { MgFormFieldModule } from '@app/src/app/form-field';
import { MgIconModule } from '@app/src/app/icon';
import { MgSpinnerModule } from '@app/src/app/spinner';

import { GenericButtonModule } from '@shared/components/button';
import { CollapsibleModule } from '@shared/components/collapsible';
import { FiltersFormModule } from '@shared/components/filters-form';
import { FormModule } from '@shared/components/form';
import { GenericModule } from '@shared/components/generic';
import { ManagerOverlayModule } from '@shared/components/manager-overlay';
import { OverlayModule } from '@shared/components/modal-overlay';
import { MultiPersonSearchModule } from '@shared/components/multi-person-search';
import { ReportTableModule } from '@shared/components/report-table';
import { SelectFieldsModule } from '@shared/components/select-fields';
import { SystemAlertModule } from '@shared/components/system-alert';
import { TextModule } from '@shared/components/text';
import { UserListFilterModule } from '@shared/components/user-list-filter/user-list-filter.module';
import { ArrayPipesModule } from '@shared/pipes';

import { CheckinManagerReportsComponent } from './checkin-manager-reports.component';
import { CheckinManagerReportHistoryComponent } from './components';
import { CheckinManagerHistoryEditComponent } from './components/checkin-manager-report-history/checkin-manager-history-edit.component';
import { CheckinManagerReportReasonsComponent } from './components/checkin-manager-report-reasons/checkin-manager-report-reasons.component';

@NgModule({
  imports: [
    // Minga dependencies
    ManagerOverlayModule,
    MgButtonModule,
    MgIconModule,
    MgSpinnerModule,
    PeopleSearchInputModule,
    MgFormFieldModule,
    SelectFieldsModule,
    GenericButtonModule,
    FormModule,
    CollapsibleModule,
    MultiPersonSearchModule,
    ReportTableModule,
    GenericModule,
    ArrayPipesModule,
    TextModule,
    OverlayModule,
    SystemAlertModule,
    UserListFilterModule,
    FiltersFormModule,

    // External dependencies
    CommonModule,
    FlexLayoutModule,
    MatButtonToggleModule,
    MatButtonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MgEmptyStateModule,
    MatTableModule,
    MatTooltipModule,
    MatSortModule,
  ],
  declarations: [
    CheckinManagerReportsComponent,
    CheckinManagerReportHistoryComponent,
    CheckinManagerReportReasonsComponent,
    CheckinManagerHistoryEditComponent,
  ],
  exports: [CheckinManagerReportsComponent],
})
export class CheckinManagerReportsModule {}
